import { WebComponent, UIRuntimeBuilder } from '@cian/mf-registry/browser';
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';

import { IApplicationContext } from '../../../shared/types/applicationContext';
import { Application } from '../../../shared/v2/containers/App';
import { IReduxStore } from '../../../shared/v2/types/redux';

export const createChatsWidgetV2Constructor =
  (context: IApplicationContext, store: IReduxStore) => (): UIRuntimeBuilder => {
    class ChatsWidget extends WebComponent {
      public constructor() {
        super();
      }
      private root: ReactDOM.Root;
      protected microfrontendName = context.config.getStrict<string>('projectName');
      protected imageVersion = context.config.getStrict<string>('version.commit');
      protected runtimeName = '/public/v2/get-chats-widget/';

      public disconnectedCallback() {
        super.disconnectedCallback();
        if (this.root) {
          this.root.unmount();
        }
      }

      public async render() {
        const reactElement = <Application {...this.props} context={context} store={store} />;

        if (this.root) {
          this.root.render(reactElement);
        } else {
          this.root = ReactDOM.createRoot(this);
          this.root.render(reactElement);
        }
      }
    }

    return { customElementConstructor: ChatsWidget };
  };
